import { render, staticRenderFns } from "./AffiliatePills.vue?vue&type=template&id=254c8f9a&scoped=true"
import script from "./AffiliatePills.vue?vue&type=script&lang=js"
export * from "./AffiliatePills.vue?vue&type=script&lang=js"
import style0 from "./AffiliatePills.vue?vue&type=style&index=0&id=254c8f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c8f9a",
  null
  
)

export default component.exports